<template>
  <section
    class="border border-blue-400 shadow-xl rounded-2xl lg:h-auto flex flex-col items-center justify-center ml-5 p-5 lg:grid lg:grid-flow-row lg:grid-cols-1 lg:gap-2"
  >
    <userinfovue />
    <eduinfovue />
    <langvue />
    <empinfovue />
    <expecinfovue />
  </section>
</template>

<script>
import userinfovue from "../totaldetails/userinfo.vue";
import eduinfovue from "../totaldetails/eduinfo.vue";
import langvue from "../totaldetails/lang.vue";
import empinfovue from "../totaldetails/empinfo.vue";
import expecinfovue from "../totaldetails/expecinfo.vue";
export default {
  name: "Details",
  components: { userinfovue, eduinfovue, langvue, empinfovue, expecinfovue },
};
</script>
